import {FC} from 'react';
import {TablePage} from './table/TablePage/TablePage';

export const App: FC = () => <TablePage />;
